import React from "react";
import PropTypes from "prop-types";

const DeleteComponent = ({ handleCancelDelete, handleConfirmDelete, question, title }) => {
    console.log(question, title)
    return (
        <>
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {title}
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>{question}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleCancelDelete}>
                                NO
                            </button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleConfirmDelete}>
                                YES
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
DeleteComponent.defaultProps = {
    question: "Are you certain that you wish to delete this record?",
    title: "DELETE",
};
DeleteComponent.propTypes = {
    handleCancelDelete: PropTypes.func,
    handleConfirmDelete: PropTypes.func,
    question: PropTypes.string,
    title: PropTypes.string,
};

export default DeleteComponent;
